<template>
  <div class="behavior-signature-wrap">
    <SandGradeCollapseGroup
      :data="convertData"
      :key="data.title">
      <template v-slot="{ childrenData }">
        <div class="attck-id" v-if="attackidSep(childrenData.attackid).length > 0">
          <span>ATT&CK ID：</span>
          <span
            v-for="(id, index) in attackidSep(childrenData.attackid)"
            :key="index"
            @click="attckClick(id, index, childrenData)"
            class="attck-id-item"
          >{{id}}</span>
        </div>
        <SandTable
          v-if="childrenData.marks[0] && childrenData.marks[0].type !== 'event'"
          class="attck-table"
          :data="handleTableData(childrenData.marks)"
        />
        <div v-else style="padding: 0 20px;">
          <BehaviorEvents :events="childrenData.marks" />
        </div>
      </template>
    </SandGradeCollapseGroup>
    <MitreDetailDialog
      :visible="mitreShow"
      :attack="attck"
      :sigs="sigs"
      :loading="loading"
      :show-detail="showDetail"
      @update:visible="mitreShow = $event"
      @update:showDetail="showDetail = $event"
    />
  </div>
</template>

<script>
// import mitre from 'utils/lib/AttckData'
// import mitreEn from 'utils/lib/AttckData.en-US.js'
import cloneDeep from 'lodash/cloneDeep'
import BehaviorEvents from '@/views/report/BehaviorEvents'
import SandTable from '@/components/report/sandTable'
import SandGradeCollapseGroup from '@/components/report/sandGradeCollapseGroup'
import keyMap from '@/assets/mock/eventdesc.json'
import { t, isZh } from 'app/i18n'
import { getAttackInfo } from 'services/report'
import MitreDetailDialog from 'components/report/MitreDetailDialog.vue' // 引入新组件

export default {
  name: 'BehaviorSignature',
  components: {
    BehaviorEvents,
    SandTable,
    SandGradeCollapseGroup,
    MitreDetailDialog
  },
  props: {
    data: {
      type: Object,
      default () {
        return {
          title: t('tracked.behaviorCount'),
          lockData: 0,
          childrenData: []
        }
      }
    },
    mitre: {
      type: Array
    }
  },
  data () {
    return {
      mitreShow: false,
      attck: null,
      showDetail: false,
      // mitre: isZh() ? mitre : mitreEn,
      showAll: false,
      keyMap,
      loading: false
    }
  },
  computed: {
    convertData () {
      const list = cloneDeep(this.data.childrenData)
      return { title: this.data.title, lockData: this.data.lockData, childrenData: list.sort((a, b) => { return b.severity - a.severity }) }
    },
    sigs() {
      const ret = {}
      if (this.data.childrenData) {
        this.data.childrenData.forEach((v) => {
          const ele = v.childrenData
          if (ele.attackid && ele.attackid !== ' ') {
            ele.attackid.split(',').forEach((id) => {
              const trimmedId = id.trim()
              if (ret[trimmedId] === undefined) {
                ret[trimmedId] = []
              }
              // 查找技术点名称
              let techName = ''
              this.mitre.forEach(tactic => {
                const foundTech = tactic.attack_list.find(tech => tech.attackid === trimmedId)
                if (foundTech) {
                  techName = foundTech.name
                }
              })
              // 添加技术点信息
              ret[trimmedId].push({
                id: trimmedId,
                desc: v.desc,
                severity: v.severity,
                name: techName
              })

              // 处理子技术点的父技术点
              if (trimmedId.includes('.')) {
                const parentId = trimmedId.split('.')[0]
                if (ret[parentId] === undefined) {
                  ret[parentId] = []
                }
                ret[parentId].push({
                  id: trimmedId,
                  desc: v.desc,
                  severity: v.severity,
                  name: techName // 子技术点使用自己的名称
                })
              }
            })
          }
        })
      }
      return ret
    },
    mitreMaxLen () {
      return this.showAttckMitre.map(item => item.techiques.length).reduce((prev, cur) => Math.max(prev, cur), 0)
    },
    showAttckMitre () {
      return this.showAll ? this.mitre : this.attckMitre
    },
    attckMitre () {
      let list = []
      let list2 = []
      for (const i in this.sigs) {
        list = list.concat(this.sigs[i])
      }
      list2 = this.mitre.map(item => {
        return {
          ...item,
          techiques: item.techiques.filter(item2 => list.find(item3 => item3.id === item2.id))
        }
      })
      return list2
    }
  },
  methods: {
    attackidSep (str) {
      // 处理attackid为空格的情况
      if (str && str !== ' ') {
        return str.split(',')
      } else {
        return []
      }
    },
    isZhcn() {
      return isZh()
    },
    attckClick(t, index, data) {
      if (!t || !this.sigs[t]) return
      this.mitreShow = true
      this.loading = true
      getAttackInfo({
        id: data.ids[index],
        attackid: t,
        taskid: this.$route.params.taskId
      }).then(res => {
        this.loading = false
        this.showDetail = true
        this.attck = res
      })
    },
    handleTableData (list) {
      if (list.length === 0) {
        return { columnData: [], tableData: [] }
      }
      const copyList = cloneDeep(list)
      let columnData
      let tableData
      const type = copyList[0].type
      if (type === 'call') {
        // 带表头的横向表格
        columnData = [
          {
            prop: 'time',
            label: this.isZhcn() ? '时间' : 'TIME',
            col: 2
          }, {
            prop: 'arguments',
            label: this.isZhcn() ? '参数' : 'ARGUMENTS',
            col: 3
          }, {
            prop: 'status',
            label: this.isZhcn() ? '状态' : 'STATUS'
          }, {
            prop: 'return_value',
            label: this.isZhcn() ? '返回值' : 'RETURN'
          }, {
            prop: 'pid',
            label: this.isZhcn() ? '进程' : 'PROCESS'
          }, {
            prop: 'tid',
            label: this.isZhcn() ? '线程' : 'THREAD'
          }, {
            prop: 'repeated',
            label: this.isZhcn() ? '重复' : 'REPEATED'
          }
        ]
        tableData = copyList.map(item => ({
          ...item.call,
          time: `<span>${item.call.time}</span><br /><span style="font-weight: bold;">${item.call.api}</span>`,
          arguments: Object.keys(item.call.arguments).map(key => {
            return `<span>${key}: ${item.call.arguments[key]}</span>`
          }).join('<br/>'),
          status: item.call.status ? t('success') : t('failed')
        }))
      } else if (type === 'generic') {
        // 纵向表头
        const result = copyList.map(item => {
          delete item.type
          return item
        })
        columnData = Object.keys(result[0]).map(item => ({
          prop: item,
          label: this.isZhcn() ? (this.keyMap[item]?.zhcn || item) : this.keyMap[item]?.enus,
          titleWidth: '120'
        }))
        tableData = result
      } else {
        columnData = [{
          prop: 'ioc',
          label: this.isZhcn() ? (this.keyMap[copyList[0].category]?.zhcn || copyList[0].category) : this.keyMap[copyList[0].category]?.enus || copyList[0].category,
          titleWidth: '120'
        }]
        tableData = copyList
      }
      return { columnData, tableData, tableProps: { isHorizontal: type !== 'call' } }
    },
    tagCalc (id) {
      var ret = {
        blue: 0,
        warning: 0,
        error: 0
      }
      if (this.sigs && this.sigs[id]) {
        this.sigs[id].forEach(function (ele) {
          if (ele.severity === 1) {
            ret.blue++
          } else if (ele.severity === 2) {
            ret.warning++
          } else if (ele.severity >= 3) {
            ret.error++
          }
        })
      }
      return ret
    },
    convertBorder (obj) {
      if (obj.error) {
        return 'red'
      } else if (obj.warning) {
        return 'orange'
      } else if (obj.blue) {
        return 'blue'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .behavior-signature-wrap {
    .attck-id {
      font-size: 14px;
      margin: 0px 20px 16px;
      // ft_color(color-center-value)
      .attck-id-item {
        // ft_color(color-main-highlight)
        color: #00ab7a;
        cursor: pointer;
        margin-right: 5px;
        &:hover  {
          filter: brightness(1.2);
        }
      }
    }
    .attck-table {
      margin: 0 20px;
    }
  }
  :deep(.attck-dialog-class) {
    height: 600px;
    .el-dialog__body {
      padding: 0 24px 0 0;
    }
  }
</style>
